import { useEffect, useState } from "react";

import { AnimateContainerProps } from "../../animate-container/AnimateContainer";
import { useLatest } from "../useLatest";

import { LOGIN_STEP_TRANSITION_MS } from "./constants";

interface UseLoginStepTransitionOptions<TStep> {
    initialStep: TStep;
    onStepChange?: (step: TStep) => void;
}

export function useLoginStepTransition<TStep>({ initialStep, onStepChange }: UseLoginStepTransitionOptions<TStep>) {
    const [animation, setAnimation] = useState<AnimateContainerProps["animation"]>("fadeIn");
    const [activeStep, setActiveStep] = useState(initialStep);
    const onStepChangeRef = useLatest(onStepChange);

    const notifyStepChange = (step: TStep) => {
        onStepChangeRef.current?.(step);
    };

    useEffect(() => {
        notifyStepChange(activeStep);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const transitionToStep = (step: TStep) => {
        setAnimation("fadeOut");
        setTimeout(() => {
            setActiveStep(step);
            notifyStepChange(step);
            setAnimation("fadeIn");
        }, LOGIN_STEP_TRANSITION_MS);
    };

    return { activeStep, animation, transitionToStep };
}
